// import _ from 'lodash';
// import domains from '../containers/Domains';
import { makeGetWithParam } from '../services/ServiceManager';

// # TODO: re-factor to use apibuilder and domains.js;

// eslint-disable-next-line import/prefer-default-export
export const getToken = async (tokenName) => {
  const foundToken = window.sessionStorage.getItem(tokenName);
  if (foundToken) {
    return JSON.parse(foundToken);
  }

  const operation = `service/token`;
  const finalResult = await makeGetWithParam(operation, null, tokenName);

  window.sessionStorage.setItem(tokenName, JSON.stringify(finalResult));
  return finalResult;
};



// WEBPACK FOOTER //
// ./src/services/TokenService.js